import { render, staticRenderFns } from "./TasksGallery.vue?vue&type=template&id=1a36886a&"
import script from "./TasksGallery.vue?vue&type=script&lang=js&"
export * from "./TasksGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports